import React, { Component } from 'react';
import {
  Modal,
  Row,
  Col,
  FormGroup,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
} from 'reactstrap';

import { updtClientName } from '../../../../helpers/api';

class NameModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: null,
      error: null,
      pending: false,
    };
  }

  handleName = (event) => {
    this.setState({ name: event.target.value });
  };

  updtName = () => {
    if (!this.state.name)
      this.setState({ error: 'Invalid name!', pending: false });
    else {
      this.setState({ pending: true, error: null });
      this._asyncRequest = updtClientName(
        this.props.publicKeyHash,
        this.state.name,
      )
        .then((res) => {
          if (res.status === 'SUCCESS') {
            this.props.loadClient();
            this.props.toggleNameModal();
          } else {
            this.setState({ error: res.error, pending: false });
          }
        })
        .catch((error) => {
          this.setState({ error: error.toString(), pending: false });
        });
    }
  };

  render() {
    return (
      <Modal
        size="md"
        isOpen={this.props.nameModal}
        centered={true}
        backdrop="static"
        wrapClassName="modal-balance"
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0" id="myLargeModalLabel">
            Update Name
          </h5>
        </div>
        <div className="modal-body">
          {this.state.error && (
            <p className="text-danger">{this.state.error}</p>
          )}
          <FormGroup>
            <Label>Name</Label>

            <Row>
              <Col sm="12">
                <InputGroup className="mb-2">
                  <InputGroupAddon addonType="prepend">
                    <span className="input-group-text">Name</span>
                  </InputGroupAddon>
                  <Input
                    type="text"
                    className="form-control"
                    onChange={this.handleName}
                    autoComplete="off"
                  />
                </InputGroup>
              </Col>
            </Row>
          </FormGroup>
          {this.state.pending ? (
            <p>Processing...</p>
          ) : (
            <Row className="mt-3">
              <Col sm="4">
                <button
                  className="btn btn-primary btn-block waves-effect waves-light"
                  type="submit"
                  onClick={() => this.props.toggleNameModal()}
                >
                  Close
                </button>
              </Col>
              <Col sm="6">
                <button
                  className="btn btn-warning btn-block waves-effect waves-light"
                  type="submit"
                  onClick={() => {
                    this.updtName();
                  }}
                >
                  Update
                </button>
              </Col>
            </Row>
          )}
        </div>
      </Modal>
    );
  }
}

export default NameModal;
